import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero, seleccionarCampo } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoOrdenesdeCompraDevolver from '../../catalogos/catalogoOrdenesdeCompraDevolver';
import CatalogoTipoRetencion from '../../catalogos/catalogoRetenciones';

export const ModalAgregarRetenOrdenPago = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habiBase, setHabiBase] = useState(true);
    const [habiAlicuo, setHabiAlicuo] = useState(true);
    const [habiRete, setHabiRete] = useState(true);
    const [habiFecha, setHabiFecha] = useState(true);
    const [visibleDat, setVisibleDat] = useState('visible');
    const [visibleDedu, setVisibleDedu] = useState('hidden');
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [tipoRetencion, setTipoRetencion] = useState(0);
    const [tipoUnidad, setTipoUnidad] = useState(0);
    const [valorUt, setValorUt] = useState(0.00);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [otroPorce, setOtroPorce] = useState(0.00);
    const [lblAlicuota, setLblAlicuota] = useState('Alicuota:');
    const [lblTotRete, setLblTotRete] = useState('Total Retención:');
    const [deduccion, setDeduccion] = useState(0);
    const [maximoRete, setMaximoRete] = useState(0.00);
    const [datos, setDatos] = useState();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtIdRetencion = useRef();
    const txtDescriret = useRef();
    const txtFechaRet = useRef();
    const txtBaseImpo = useRef();
    const txtPorceIva = useRef();
    const txtMontoIva = useRef();
    const txtMontoCompro = useRef();
    const txtAlicuota = useRef();
    const txtTotalRete = useRef();
    const txtDeducible = useRef();

    const txtUbi = useRef();

    const txtTipo = useRef();
    const txtMotivo = useRef();
    const txtIdordenpago = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
        setHabiAlicuo(true);
        setHabiBase(true);
        setHabiFecha(true);
        setVisibleDedu('hidden');
        setVisibleDat('visible');
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onDatos(datos);
        props.onHideCancela();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarRetencion(event.target.value);
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaRetenciones = (idretencion, descripcion) => {
        setMostrar4(false);
        if (props.operacion === 1) {
            for (let i = 0; i < props.retenciones.length; i++) {
                if (idretencion === props.retenciones[i].idretencion) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Esta Retención ya fue Seleccionada !', icono: 'informacion' });
                    return;
                } 
            }
            txtIdRetencion.current.value = idretencion;
            setActivo(false);
            seleccionarRetencion(idretencion);

        } 

    }

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarRetencion = (id) => {

        let campos = '*';
        let nomtab = 'tiporetencion';
        let nomid = 'idtiporetencion';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {
                if (parseInt(response.data.idtiporetencion) > 0) {
                    if (parseInt(response.data.idtiporetencion) === 2){
                        txtIdRetencion.current.value = '';
                        txtIdRetencion.current.focus();
                        setActivate(false);
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Retención se debe agregar en la pestaña Retención I.S.L.R.', icono: 'informacion' });
                        return;
                    } 
                    if (props.operacion === 1){
                        for (let i = 0; i < props.retenciones.length; i++) {
                            if(props.retenciones[i].idtiporetencion === txtIdRetencion.current.value){
                                setActivate(false);
                                txtIdRetencion.current.value = '';
                                txtIdRetencion.current.focus();
                                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El TIPO DE RETENCION YA EXISTE', icono: 'informacion' });
                                return;
                            }
                        }
                        setHabiFecha(false);
                        txtFechaRet.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                    }
                    
                    setTipoRetencion(response.data.tipo);
                    if (response.data.tipo === 0) {
                        txtAlicuota.current.value = '75,00';
                    } else if (response.data.tipo === 1) {
                        let n = response.data.deducible;
                        txtDeducible.current.value = n !== null ? formatMoneda(n.toString().replace(',', '').replace('.', ','), ',', '.', 2) : '0,00';
                        txtAlicuota.current.value = formatMoneda(props.montoislr.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    } else {
                        txtAlicuota.current.value = '0,00';
                    }
                    setOtroPorce(response.data.otro);
                    txtDescriret.current.value = response.data.descripcion.trim();
                    setTipoUnidad(parseInt(response.data.unidad));
                    if (response.data.unidad === 0) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota('Por Ciento (%):');
                        setHabiRete(true);
                    } else if (response.data.unidad === 1) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota(' Por Mil (‰):');
                        setHabiRete(true);
                    } else if (response.data.unidad === 2) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota('Unid Tributaria:');
                        setHabiRete(true);
                    } else if (response.data.unidad === 3) {
                        setLblTotRete('Monto a Retener:');
                        setVisibleDat('hidden');
                        setHabiAlicuo(true);
                        setHabiRete(false);
                    } else if (response.data.unidad === 4) {
                        setLblTotRete('Total Retención:');
                        setVisibleDat('visible');
                        setHabiAlicuo(false);
                        setLblAlicuota(' X '+parseInt(otroPorce)+' (‰):');
                        setHabiRete(true);
                    }
                    if (props.operacion === 2){
                        setHabiFecha(false);
						txtAlicuota.current.value = formatMoneda(props.retencionsel.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                        txtTotalRete.current.value = formatMoneda(props.retencionsel.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                        txtFechaRet.current.value = moment.utc(props.retencionsel.fecha).format('YYYY-MM-DD');
					} else {
                        calculariva(response.data.tipo);
                    }

                    setActivo(false);
                    txtFechaRet.current.focus();
                } else {
                    txtIdRetencion.current.value = '';
                    txtIdRetencion.current.focus();
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Retención no existe.', icono: 'informacion' });
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const calculariva = (tiporet) => {
		let sinpuntoiva = txtMontoIva.current.value.replace(/\./g, "");
		let sincomaiva = sinpuntoiva.replace(',', '.');
        let sinpuntodeducible = txtDeducible.current.value.replace(/\./g, "");
		let sincomadeducible = sinpuntodeducible.replace(',', '.');
		let val1 = 0.00;
        val1 = parseFloat(txtMontoCompro.current.value.trim().replace(/\./g, "").replace(",", ".")) - parseFloat(txtMontoIva.current.value.trim().replace(/\./g, "").replace(",", ".")) - parseFloat(props.facturasel.exento);
        val1 = Math.round(parseFloat(val1) * Math.pow(10, 2)) / Math.pow(10, 2);
        txtBaseImpo.current.value = formatMoneda(val1.toString().replace(',', '').replace('.', ','), ',', '.', 2);
		if (tiporet !== 3 || tiporet !== 4 || tiporet !== 6) {
			let sinpuntosiniva = txtBaseImpo.current.value.replace(/\./g, "");
			let sincomasiniva = sinpuntosiniva.replace(',', '.');
			let val = (parseFloat(sincomaiva)) / parseFloat(sincomasiniva);
            val = Math.round(parseFloat(val*100) * Math.pow(10, 4)) / Math.pow(10, 4);
			if (val > 0) {
                txtPorceIva.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			} else {
				txtPorceIva.current.value = '0,00';
			}
		} 

		if (tiporet === 1 && props.natural === true && (val1 > parseFloat(sincomadeducible))) {
			setVisibleDedu('visible');
			setDeduccion(1);
		}
	}

    const calcular = () => {
		let valido = true;
		
		if (txtAlicuota.current.value.length > 0 && tipoUnidad === 0
				&& tipoRetencion === 0) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let sinpuntototaliva = txtMontoIva.current.value.replace(/\./g, "");
			let sincomatototaliva = sinpuntototaliva.replace(',', '.');
			let val = parseFloat(sincomatototaliva) / 100 * parseFloat(sincomaunidad);
			val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(/\./g, "");
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');

			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtAlicuota.current.value.length > 0 && tipoUnidad === 0
				&& tipoRetencion > 1) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let sinpuntototaliva = txtBaseImpo.current.value.replace(/\./g, "");
			let sincomatototaliva = sinpuntototaliva.replace(',', '.');
			let val = parseFloat(sincomatototaliva) / 100 * parseFloat(sincomaunidad);
			val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');
			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtAlicuota.current.value.length > 0 && tipoUnidad === 0
				&& tipoRetencion === 1) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let sinpuntototaliva = txtBaseImpo.current.value.replace(/\./g, "");
			let sincomatototaliva = sinpuntototaliva.replace(',', '.');
			let sinpuntodeducible = txtDeducible.current.value.replace(/\./g, "");
			let sincomadeducible = sinpuntodeducible.replace(',', '.');
			let val = 0.00;
			if (deduccion === 0) {
				val = parseFloat(sincomatototaliva) / 100 * parseFloat(sincomaunidad);
				val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			}else {
				
			    val = (parseFloat(sincomatototaliva) - parseFloat(sincomadeducible)) / 100 * parseFloat(sincomaunidad);
			    val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			}

			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');

			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtAlicuota.current.value.length > 0 && tipoUnidad === 1) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let sinpuntototaliva = txtBaseImpo.current.value.replace(/\./g, "");
			let sincomatototaliva = sinpuntototaliva.replace(',', '.');
			let val = parseFloat(sincomatototaliva) / 1000 * parseFloat(sincomaunidad);
			val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');
			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtAlicuota.current.value.length > 0 && tipoUnidad === 2) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let tributaria = valorUt;
			let val = parseFloat(tributaria) * parseFloat(sincomaunidad);
			val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');
			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtAlicuota.current.value.length > 0 && tipoUnidad === 4) {
			let sinpuntounidad = txtAlicuota.current.value.replace(/\./g, "");
			let sincomaunidad = sinpuntounidad.replace(',', '.');
			let sinpuntototaliva = txtBaseImpo.current.value.replace(/\./g, "");
			let sincomatototaliva = sinpuntototaliva.replace(',', '.');
			let val = parseFloat(sincomatototaliva) / parseFloat(otroPorce) * parseFloat(sincomaunidad);
			val = Math.round(parseFloat(val) * Math.pow(10, 4)) / Math.pow(10, 4);
			txtTotalRete.current.value = formatMoneda(val.toString().replace(',', '').replace('.', ','), ',', '.', 2);
			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');
			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtAlicuota.current.value = '0,00';
				txtTotalRete.current.value = '0,00';
				txtAlicuota.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} else if (txtTotalRete.current.value.length > 0 && (tipoRetencion === 3 || tipoRetencion === 4)) {

			let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
			let sincomatototalret = sinpuntototaret.replace(',', '.');
			let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
			let sincomatotot = sinpuntotot.replace(',', '.');
			if ((parseFloat(sincomatototalret) + parseFloat(props.totalrete)) > parseFloat(sincomatotot)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden.', icono: 'informacion' });
				valido = false;
				txtTotalRete.current.value = '0,00';
				txtTotalRete.current.focus();
			} else {
				btnAcepta.current.focus();
			}

		} 

	}

    const seleccionarValorUnidad = () => {
        let campos = '*';
        let nomtab = 'unidadtributaria';
        let nomid = 'anio';
        let nanio = new Date(txtFechaRet.current.value.replace("-',',")).getFullYear();
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${nanio}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {
                if (parseInt(response.data.anio) > 0) {
                    setValorUt(response.data.valor);
                } else {
                    setValorUt(0.00);
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })
	}

    const handleRetenciones = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarRetencion(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        let sinpuntototaret = txtTotalRete.current.value.replace(/\./g, "");
		let sincomatototalret = sinpuntototaret.replace(',', '.');
		let sinpuntotot = txtMontoCompro.current.value.replace(/\./g, "");
		let sincomatotot = sinpuntotot.replace(',', '.');
		
		if (txtIdRetencion.current.value.trim() === '' || txtDescriret.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir una Retención', icono: 'informacion' });
			sigue = false;
			txtIdRetencion.current.focus();
		} else if (txtFechaRet.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La fecha de la retención no es valida', icono: 'informacion' });
			sigue = false;
			txtFechaRet.current.focus();
		} else if (new Date(txtFechaRet.current.value).getFullYear() !== anioefis) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El año no debe ser diferente al año del Ejercicio Fiscal actual', icono: 'informacion' });
            sigue = false;
            txtFechaRet.current.focus();
        } else if (txtAlicuota.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no debe ser Vacio', icono: 'informacion' });
			sigue = false;
			if (habiAlicuo){
                txtAlicuota.current.focus();
            } else {
                txtTotalRete.current.focus();
            }
		} else if (txtTotalRete.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no debe ser Vacio', icono: 'informacion' });
			sigue = false;
            if (habiAlicuo){
                txtAlicuota.current.focus();
            } else {
                txtTotalRete.current.focus();
            }
		} else if (parseFloat(sincomatototalret) > parseFloat(sincomatotot)) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido no de debe ser Mayor que el Total de la Orden', icono: 'informacion' });
			sigue = false;
			txtAlicuota.current.value = '0,00';
			txtTotalRete.current.value = '0,00';
			if (habiAlicuo){
                txtAlicuota.current.focus();
            } else {
                txtTotalRete.current.focus();
            }
		} else if (parseFloat(sincomatototalret) <= 0) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Retenido de debe ser Mayor a 0,00', icono: 'informacion' });
			sigue = false;
			txtAlicuota.current.value = '0,00';
			txtTotalRete.current.value = '0,00';
			if (habiAlicuo){
                txtAlicuota.current.focus();
            } else {
                txtTotalRete.current.focus();
            }
		} 
		
		if(props.operacion===1 && tipoRetencion != 5){
			if(parseFloat(txtTotalRete.current.value.replace('.', '').replace(',', '.'))>maximoRete){
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La suma de las retenciones no puede\nser mayor al total de la factura', icono: 'informacion' });
				sigue = false;
				if (habiAlicuo){
                    txtAlicuota.current.focus();
                } else {
                    txtTotalRete.current.focus();
                }
			}
		}

        if (sigue) {

            seleccionarDatosRetencion();

        }

    };

    const seleccionarDatosRetencion = () => {
        var data = [];
        let iddeta = props.operacion === 1 ? '0' : props.retencionsel.iddetalle;
        data.push({
            iddetalle: iddeta,
            numfactura: props.facturasel.numfactura,
            idtiporetencion: txtIdRetencion.current.value,
            descripcion: txtDescriret.current.value,
            alicuota: parseFloat(txtAlicuota.current.value.replace(/\./g, '').replace(',', '.')),
            totalrete: parseFloat(txtTotalRete.current.value.replace(/\./g, '').replace(',', '.')),
            fecha: txtFechaRet.current.value,
            tiporetencion: tipoRetencion,
        });
        setDatos(data);
        let msg = ''
        if (props.operacion === 1) {
            msg = 'registro creado correctamente.';
        } else if (props.operacion === 2) {
            msg = 'registro modificado correctamente.';
        } else if (props.operacion === 3) {
            msg = 'registro eliminado correctamente.';
        }
        setMensaje({ mostrar: true, titulo: 'Exito.', texto: msg, icono: 'exito' });
        
    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
          }
        if (event.which === 13 || typeof event.which === "undefined") {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace('.', '').replace(',', '.')) === 0.00) {
                event.target.value = "0,00";
            } */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.name === 'alicuota' || event.target.name === 'totalrete'){
                calcular();
            }
            if (event.which === 13) {
                if (event.target.name === 'baseimpo') {
                    txtAlicuota.current.focus();
                } else if (event.target.name === 'alicuota') {
                    btnAcepta.current.focus()
                } else if (event.target.name === 'totalrete') {
                    btnAcepta.current.focus()
                } 
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };

    const handleInputChange = (event) => {
        //setActiveIndex(1);
        if (event.which === 13 || typeof event.which === "undefined") {
            //calcular();
            if (event.which === 13 && event.target.value !== '') {
                if (event.target.name === 'fecharete') {
                    if (tipoUnidad === 2){
					    seleccionarValorUnidad();
                        txtAlicuota.current.focus();
                    } else if (tipoUnidad === 3){
                        txtTotalRete.current.focus();
                    } else if (tipoUnidad === 0 || tipoUnidad === 1 || tipoUnidad === 4){
                        txtAlicuota.current.focus();
                    }
                } 
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };

    const onChange = (e) => {

        if (e.target.name === 'idtiporet') {
            txtDescriret.current.value = '';
            txtAlicuota.current.value = '';
            txtTotalRete.current.value = '';
            txtFechaRet.current.value = '';
            setHabiAlicuo(true);
            setHabiFecha(true);
            setTipoRetencion(0);
            setTipoUnidad(0);
            setVisibleDedu('hidden')
        }

    };

    const handleDobleClick = (e) => {
        setHabiBase(false);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setMaximoRete(parseFloat(props.facturasel.total)-parseFloat(props.totalrete))
                if (props.operacion === 1) {
                    txtBaseImpo.current.value = formatMoneda(props.facturasel.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtPorceIva.current.value = formatMoneda(props.facturasel.porceiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    let moniva = parseFloat(props.facturasel.total) - parseFloat(props.facturasel.baseimponible) - parseFloat(props.facturasel.exento);
                    moniva = Math.round(parseFloat(moniva) * Math.pow(10, 2)) / Math.pow(10, 2);
                    txtMontoIva.current.value = formatMoneda(moniva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.facturasel.total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    calculariva(tipoRetencion);
                } else {
                    txtIdRetencion.current.value = props.retencionsel.idtiporetencion;
                    txtBaseImpo.current.value = formatMoneda(props.facturasel.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtPorceIva.current.value = formatMoneda(props.facturasel.porceiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    let moniva = parseFloat(props.facturasel.total) - parseFloat(props.facturasel.baseimponible) - parseFloat(props.facturasel.exento);
                    moniva = Math.round(parseFloat(moniva) * Math.pow(10, 2)) / Math.pow(10, 2);
                    txtMontoIva.current.value = formatMoneda(moniva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.facturasel.total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    /*txtDescriret.current.value = props.retencionsel.descripcion;
                    txtFechaRet.current.value = moment.utc(props.retencionsel).format('YYYY-MM-DD');
                    txtBaseImpo.current.value = formatMoneda(props.facturasel.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtPorceIva.current.value = formatMoneda(props.facturasel.porceiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    let moniva = parseFloat(props.facturasel.total) - parseFloat(props.facturasel.baseimponible) - parseFloat(props.facturasel.exento);
                    moniva = Math.round(parseFloat(moniva) * Math.pow(10, 4)) / Math.pow(10, 4);
                    txtMontoIva.current.value = formatMoneda(moniva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoCompro.current.value = formatMoneda(props.facturasel.total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtAlicuota.current.value = formatMoneda(props.retencionsel.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalRete.current.value = formatMoneda(props.retencionsel.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    setHabiFecha(false);*/
                    seleccionarRetencion(props.retencionsel.idtiporetencion);
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>Retención</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoTipoRetencion
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptarRetenciones={handleAceptaRetenciones}
                />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='col-md-12 row mx-auto'>
                    <div className='input-group input-group-sm col-md-3 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                        <input type="text" name='idtiporet' disabled={props.operacion === 4 || props.operacion === 2 ? true : deshabilitado} ref={txtIdRetencion} onChange={onChange} onKeyUp={handleRetenciones} onBlur={handleRetenciones} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                        <button disabled={props.operacion === 4 || props.operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-info" ><i className="fa fa-search"></i> </button>

                    </div>
                    <div className='col-md-4'></div>
                    <div className=' input-group input-group-sm col-md-5 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Fecha de Retención:</label>
                        <input type="date" name='fecharete' disabled={habiFecha} ref={txtFechaRet} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onKeyUp={handleInputChange} onBlur={handleInputChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-12 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                        <textarea style={{ height: 40 }} type="textarea" disabled={true} ref={txtDescriret} name='codigo' className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>

                        <label className="input-group-text" onDoubleClick={handleDobleClick} id="inputGroup-sizing-sm">Base Imponible:</label>
                        <input type="text" autocomplete="off" disabled={habiBase} ref={txtBaseImpo} name='baseimpo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">% IVA:</label>
                        <input type="text" disabled={true} ref={txtPorceIva} name='codigo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Monto IVA:</label>
                        <input type="text" disabled={true} ref={txtMontoIva} name='codigo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Total Compromiso:</label>
                        <input type="text" disabled={true} ref={txtMontoCompro} name='codigo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">{lblAlicuota}</label>
                        <input type="text" autocomplete="off" disabled={habiAlicuo} ref={txtAlicuota} name='alicuota' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto'>

                        <label className="input-group-text" id="inputGroup-sizing-sm">{lblTotRete}</label>
                        <input type="text" autocomplete="off" disabled={habiRete} ref={txtTotalRete} name='totalrete' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDedu}}>

                        <label className="input-group-text" id="inputGroup-sizing-sm">Deducible:</label>
                        <input type="text" disabled={true} ref={txtDeducible} name='codigo' className="text-right form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />

                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>
                    </div>
                    <div className=' input-group input-group-sm col-md-4 mb-2 mx-auto' style={{visibility:visibleDat}}>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}